// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"5884ce91","488":"bf92bebf","582":"bd17be46"}[chunkId] + ".chunk.js";
};